require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./impact-of-police-behavior-on-victim-reports.json") })
        }
      }, "path---impact-of-police-behavior-on-victim-reports");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---impact-of-police-behavior-on-victim-reports!./.cache/json/impact-of-police-behavior-on-victim-reports.json
// module id = 907
// module chunks = 231608221292675